import { Box } from "@mui/material"
import { FixedNumber } from "ethers"
import React, { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import AmountInput from "src/components/AmountInput"
import Button from "src/components/Button"
import { XFER } from "src/constants"
import { BIG_ZERO } from "src/constants/bigNumber"
import { usePoolTokenBalances } from "src/state/wallet/hooks"
import {
  getRawAmount,
  sanitizeStringForFN,
} from "src/utils/parseStringToBigNumber"

interface Props {
  remark: ReactNode
  onConfirm: () => void
  value: string
  onChange: (value: string) => void
}

const InputStep = ({ remark, onConfirm, value, onChange }: Props) => {
  const { t } = useTranslation()
  const tokenBalances = usePoolTokenBalances()
  const balance = tokenBalances?.[XFER.symbol] || BIG_ZERO
  const insufficientAmount = getRawAmount(balance)
    .subUnsafe(FixedNumber.from(sanitizeStringForFN(value)))
    .isNegative()

  const disableTransaction =
    FixedNumber.from(sanitizeStringForFN(value)).isZero() || insufficientAmount

  return (
    <Box>
      <AmountInput
        value={value}
        onChange={onChange}
        tokenSymbol={XFER.symbol}
        label={t("Deposit")}
        balance={balance}
      />
      {remark}
      <Button fullWidth disabled={disableTransaction} onClick={onConfirm}>
        {insufficientAmount ? t("Insufficient Balance") : t("Deposit in Vault")}
      </Button>
    </Box>
  )
}

export default InputStep
